export default __webpack_public_path__ + "static/media/blood2.0cbb30eb.png";